import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { RecordingContext } from "../pages/RecordingPage";
import { Button } from "semantic-ui-react";
import { recordingStatuses } from "../../constants";

const RecordingCommitButtons = () => {
  const {
    recording,
    updateRecording,
    changeRecording,
    reviewRecording,
  } = useContext(RecordingContext);
  const reviewer = useSelector((state) => state.mode.reviewer);
  const isRecording = useSelector((state) => state.microphone.isRecording);

  const onCommit = (newStatus) => {
    updateRecording({ ...recording, user_status: newStatus });
    changeRecording(reviewer ? "review" : "jump");
  };

  const UserButtonGroup = () => (
    <Button.Group floated="left">
      {!reviewer && (
        <>
          <Button
            color="grey"
            content="Skip"
            onClick={() => changeRecording("skip")}
            disabled={isRecording}
          />
          <Button.Or />
        </>
      )}
      <Button
        color="red"
        content="Mark Bad"
        inverted={reviewer}
        onClick={() => onCommit(recordingStatuses.BAD)}
        disabled={
          isRecording || recording.user_status === recordingStatuses.BAD
        }
      />
      <Button.Or />
      <Button
        color="orange"
        content="Mark Questionable"
        inverted={reviewer}
        onClick={() => onCommit(recordingStatuses.QUESTIONABLE)}
        disabled={
          isRecording ||
          recording.user_status === recordingStatuses.QUESTIONABLE
        }
      />
      <Button.Or />
      <Button
        color="green"
        content="Save and Mark Done"
        inverted={reviewer}
        onClick={() => onCommit(recordingStatuses.DONE)}
        disabled={
          isRecording ||
          !(recording.user_key || recording.tmpUrl) ||
          (recording.user_status === recordingStatuses.DONE &&
            !recording.tmpUrl)
        }
      />
    </Button.Group>
  );

  const ReviewerButtonGroup = () => (
    <Button.Group floated="right">
      <Button
        color="red"
        content="Redo"
        onClick={() => reviewRecording(recordingStatuses.REDO)}
        disabled={
          !recording.user_key ||
          recording.reviewer_status === recordingStatuses.REDO
        }
      />
      <Button.Or />
      <Button
        color="green"
        content="Approved"
        onClick={() => reviewRecording(recordingStatuses.APPROVED)}
        disabled={
          !recording.user_key ||
          recording.reviewer_status === recordingStatuses.APPROVED
        }
      />
    </Button.Group>
  );

  return (
    <div style={{ margin: "40px 0 40px 0" }}>
      <UserButtonGroup />
      {reviewer && <ReviewerButtonGroup />}
    </div>
  );
};

export default RecordingCommitButtons;
